module.exports = __webpack_public_path__ + "img/tik-tok.29d513a7.svg";